export const certificationsTranslations = {
  pt: {
    "advanced-prompt-engineering": {
      title: "Advanced Prompt Engineering",
      description: "Técnicas avançadas de engenharia de prompts para IA Generativa",
    },
    "prompt-engineering-chatgpt": {
      title: "Prompt Engineering for ChatGPT",
      description: "Fundamentos de prompt engineering e otimização de LLMs",
    },
    "ux-writing-chatbots": {
      title: "UX Writing para Chatbots",
      description: "Design conversacional e escrita para interfaces de diálogo",
    },
    "ux-design": {
      title: "UX Design",
      description: "Fundamentos de design de experiência do usuário e prototipagem",
    },
    "journalism": {
      title: "Comunicação Social: Jornalismo",
      description: "Bacharelado em Jornalismo com foco em comunicação digital",
    },
  },
  en: {
    "advanced-prompt-engineering": {
      title: "Advanced Prompt Engineering",
      description: "Advanced prompt engineering techniques for Generative AI",
    },
    "prompt-engineering-chatgpt": {
      title: "Prompt Engineering for ChatGPT",
      description: "Fundamentals of prompt engineering and LLM optimization",
    },
    "ux-writing-chatbots": {
      title: "UX Writing for Chatbots",
      description: "Conversational design and writing for dialogue interfaces",
    },
    "ux-design": {
      title: "UX Design",
      description: "Fundamentals of user experience design and prototyping",
    },
    "journalism": {
      title: "Social Communication: Journalism",
      description: "Bachelor's degree in Journalism with focus on digital communication",
    },
  },
};
